import createDataContext from './createDataContext';
import * as checklistActions from './actions/checklistActions';
import { checklistReducer, initialState } from './reducers/checklistReducer';

export const { Context: ChecklistContext, Provider } = createDataContext(
  checklistReducer,
  checklistActions,
  initialState
);
